import { z } from 'zod';
import { CovalentBalanceItemSchema } from './types';
export var sendFundsSchema = z.object({
    tokenAmount: z.string().min(0, 'Token amount can not be empty.'),
    tokenUsdAmount: z.string().optional(),
    quoteParams: z.object({
        quoteId: z.string().min(1),
    }),
    transferParams: z.object({
        from_address: z.string().min(1),
        to_address: z.string().min(1),
        token_address: z.string().min(1),
        token_amount: z.string().min(0),
        token_amount_formatted: z.number().min(0),
        usd_value: z.number().min(0),
        symbol: z.string().min(1),
        name: z.string().min(1),
        decimals: z.number().min(1),
        network: z.number().min(1),
    }),
    sendTo: z
        .string()
        // .min(4, 'Username must have at least 4 characters.')
        .superRefine(function (val, ctx) {
        // username
        // EVM address are max 42 chars and starts with 0x
        if (val.length > 20 && val.length <= 42) {
            if (!val.startsWith('0x')) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Ethereum EVM address must start with 0x and must have 42 characters. Please verify the address",
                });
            }
        }
        // SVM address are max 44 chars
    }),
});
var tradeAmountSchema = z
    .string()
    .min(1, 'Token amount can not be empty.')
    .superRefine(function (val, ctx) {
    if (Number(val) <= 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Amount must be higher than 0',
        });
    }
});
export var BuySellAssetPageSchema = z.object({
    tradeAmount: tradeAmountSchema,
    tradeSide: z.enum(['buy', 'sell']),
    fromToken: CovalentBalanceItemSchema,
    toToken: CovalentBalanceItemSchema,
});
export var TradeAssetsPageSchema = z.object({
    tokenAmount: tradeAmountSchema.optional(),
    usdAmount: tradeAmountSchema,
    fromToken: CovalentBalanceItemSchema,
    toToken: CovalentBalanceItemSchema,
});
